// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2Ktmz","label":"Section_label__3T5LE","contentWrap":"Section_contentWrap__1kfje","footer":"Section_footer__ZPH6b","footerInner":"Section_footerInner__3js4y"};